import { Box, CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import useAuth from "src/hooks/useAuth";
import useQueryParams from "src/hooks/useQueryParams";
import axiosInstance from "src/utils/axios";
import { setSession } from "src/utils/jwt";

const ShopLogin = () => {
  const { queryObject } = useQueryParams();
  const { token } = queryObject || {};
  const { getUser } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    const makeRequest = async () => {
      try {
        const { status, data } = await axiosInstance.get(
          `api/user-verify-details?token=${token}`
        );

        console.log(data, "data");
        if (status === 200) {
          const { access_token } = data;
          const { user, menu_lists } = data.data;
          localStorage.setItem("menu", JSON.stringify(menu_lists));
          console.log(user, "usr");
          setSession(token);
          enqueueSnackbar("verified", { variant: "success" });
          localStorage.setItem("isAdmin", Boolean(user.is_super_admin));
          localStorage.setItem("isSubAdmin", Boolean(user.is_sub_admin));
          window.location = "/user/dashboard";
          getUser();
        }
      } catch (error) {
        console.error(error);
        enqueueSnackbar(error.message, { variant: "error" });
      }
    };

    makeRequest();
  }, []);
  return (
    <Box
      sx={{
        alignItems: "center",
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default ShopLogin;
